import React, { useEffect } from "react";
import about from "../assets/images/profil.png";
import cv from "../assets/download/Frontend_Firhan_Ramadhan_CV.pdf";
import AOS from "aos";
import "aos/dist/aos.css";

const styles = {
  backgroundImage: "linear-gradient(#D31027, #EA384D)",
};

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <div
      className="flex flex-col items-center font-montserrat pb-10 lg:pb-0 lg:flex-row lg:flex-wrap md:flex-row md:px-5 md:mt-5 lg:px-10 xl:justify-center"
      id="about"
      data-aos="fade-right"
    >
      <img src={about} alt="About Me" className="lg:w-1/2 md:w-1/2 xl:w-1/3" />
      <div className="py-1 flex flex-col lg:w-1/2 md:w-1/2 xl:w-1/3 lg:flex lg:flex-col">
        <h3 className="font-semibold text-2xl text-center">About Me</h3>
        <p className="text-sm md:text-xs xl:text-sm text-center px-8">
          Hello, I am Firhan Ramadhan. I am a front end web developer from
          Tangerang, Indonesia. As a programmer, I always try to leave every bit
          of code I touch more readable, modular, performant and accesible than
          I found it. Also, I am familiar with the technical specifications for
          designing prototypes and guides.
        </p>
        <a href={cv} className="text-sm self-center w-2/6 lg:w-2/6" download>
          <button
            className="px-3 w-2/6 w-full lg:w-full py-2 text-white font-semibold rounded shadow mt-2"
            style={styles}
          >
            Download CV
          </button>
        </a>
      </div>
    </div>
  );
};

export default About;
